import BasicContactVendor from '../enums/basicContactVendor';

const opCityPrivacyPolicyParagraph = `<div class="form__legal">By proceeding, you consent to receive calls and texts at the number you 
provided, including marketing by autodialer and prerecorded and artificial voice, and email, from Realtor.com  (Move Sales, Inc.) 
about your inquiry and other home-related matters, but not as a condition of any purchase. You also agree to Realtor.com ’s <a target="_blank" 
href="https://url.us.m.mimecastprotect.com/s/9yVzC82NjKsPOn2gU1hmSybunG?domain=realtor.com/" rel="nofollow sponsored noopener noreferrer">Terms of Use</a> 
and to Realtor.com ’s <a target="_blank" href="https://url.us.m.mimecastprotect.com/s/h06-C9rNkYTNRoljT3iGSqPd46?domain=realtor.com/" 
rel="nofollow sponsored noopener noreferrer">Privacy Policy</a> regarding information relating to you. Msg/data rates may apply. 
This consent applies even if you are on a corporate, state, or national Do Not Call list.<br>
By providing your name and contact information, you consent and agree to receive email marketing communications from NewHomeSource.  Your Agreement 
is not a condition of purchasing any property, goods, or services, and you may call us instead of submitting your information online. Consult our 
<a target="_blank" href="https://www.newhomesource.com/privacypolicy">Privacy Policy</a> for additional information, including unsubscribe options. 
You also agree to our <a target="_blank" href="https://www.newhomesource.com/privacypolicy">Privacy Policy</a> and 
<a target="_blank" href="https://www.newhomesource.com/termsofuse">Terms of Use</a>.</div>`;

const defaultPrivacyPolicyParagraph = `<div class="form__legal">By providing your name and contact information and clicking the Learn More button, 
you consent and agree to receive marketing communications from NewHomeSource and {0}, including emails, calls or text messages using an automatic 
telephone dialing system or an artificial or prerecorded voice. You also agree to our <a target="_blank" 
href="https://www.newhomesource.com/privacypolicy">Privacy Policy</a>, including <a target="_blank" 
href="https://www.newhomesource.com/termsofuse#tcpaanchor">TCPA Policy</a> and <a target="_blank" 
href="https://www.newhomesource.com/termsofuse">Terms of Use</a>. Your agreement is not a condition to purchasing any property, 
goods or services, and you may call us instead of submitting the information online. You also acknowledge 
and agree that you can revoke your authorization at any time. Your consent herein also applies to any future registration on national or state 
Do-No-Call lists. For mobile phones, standard message and data charges apply. Consult our Privacy Policy for additional information, 
including unsubscribe options.</div>`;

/**
 * Returns the privacy policy paragraph for basic listings according to the contact vendor name.
 * @param {string} contactVendorName the contact vendor name.
 * @returns {string} - The privacy policy paragraph.
 */
function getBasicPrivacyPolicyParagraph(contactVendorName) {

    switch (contactVendorName) {
        case BasicContactVendor.OpCity.name:
            return opCityPrivacyPolicyParagraph;
        default:
            return defaultPrivacyPolicyParagraph.replace('{0}', contactVendorName);
    }
}

export default getBasicPrivacyPolicyParagraph;